var _g, _line, _g2, _path, _line2, _line3, _g3, _line4, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 92,
    viewBox: "0 0 88 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.1717 12.0007L48.2219 7.05093L49.6361 5.63672L56.0001 12.0007L49.6361 18.3646L48.2219 16.9504L53.1717 12.0007Z",
    fill: "#78C15A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1717 12.0007L48.2219 7.05093L49.6361 5.63672L56.0001 12.0007L49.6361 18.3646L48.2219 16.9504L53.1717 12.0007Z",
    fill: "#78C15A"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 12,
    x2: 54,
    y2: 12,
    stroke: "#78C15A",
    strokeWidth: 2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3_205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8283 11.9993L15.7781 16.9491L14.3639 18.3633L7.9999 11.9993L14.3639 5.6354L15.7781 7.0496L10.8283 11.9993Z",
    fill: "#78C15A"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3_205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8283 11.9993L15.7781 16.9491L14.3639 18.3633L7.9999 11.9993L14.3639 5.6354L15.7781 7.0496L10.8283 11.9993Z",
    fill: "#78C15A"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 24,
    y2: -1,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 7 2)",
    stroke: "#78C15A",
    strokeWidth: 2
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.3719 68.1235L56.2845 61.5484V54.375H55.2878L53.2674 61.9385L6.0625 61.9312V65.6693C6.0625 67.9186 8.32948 68.2713 9.01404 68.2713C9.02861 68.2713 9.0567 68.2713 9.07438 68.2713C9.07438 71.0678 11.3518 73.3421 14.1483 73.3421C14.7049 73.3421 15.2324 73.2297 15.7338 73.0632C16.2332 73.2297 16.7596 73.3421 17.3173 73.3421C18.8882 73.3421 20.2761 72.6107 21.2072 71.4871C22.1384 72.6107 23.5273 73.3421 25.0951 73.3421C25.6174 73.3421 26.1116 73.2401 26.586 73.0924C27.0604 73.2401 27.5546 73.3421 28.0768 73.3421C30.8733 73.3421 33.1476 71.0678 33.1476 68.2713H51.3188V72.8146H52.278V71.2374L53.7491 71.51V73.6448H54.7083V68.2692C55.1474 68.2692 55.6218 68.2692 56.375 68.2692L56.3719 68.1235ZM12.6782 70.3021C12.0467 69.8454 11.6316 69.1077 11.6316 68.2692C11.6316 67.4286 12.0488 66.6899 12.6803 66.2332C12.4036 66.8574 12.2454 67.5441 12.2454 68.2692C12.2465 68.9923 12.4036 69.6779 12.6782 70.3021ZM17.3173 70.7838C15.9294 70.7838 14.8027 69.6581 14.8027 68.2692C14.8027 66.8782 15.9284 65.7525 17.3173 65.7525C18.7083 65.7525 19.8339 66.8782 19.8339 68.2692C19.835 69.6581 18.7083 70.7838 17.3173 70.7838ZM23.3525 70.0753C22.8781 69.6186 22.5805 68.9808 22.5805 68.2702C22.5805 67.5586 22.8781 66.9198 23.3525 66.461C23.135 67.0249 23.0029 67.6304 23.0029 68.2702C23.0029 68.9069 23.135 69.5135 23.3525 70.0753ZM28.0768 70.7838C26.6858 70.7838 25.5602 69.6581 25.5602 68.2692C25.5602 66.8782 26.6858 65.7525 28.0768 65.7525C29.4147 65.7525 30.4999 66.8012 30.5758 68.1235C30.58 68.1724 30.5904 68.2193 30.5904 68.2692C30.5914 69.6581 29.4657 70.7838 28.0768 70.7838ZM53.7481 70.5331L52.277 70.2605V67.8343H53.7481V70.5331Z",
    fill: "#78C15A"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 59,
    y1: 1,
    x2: 59,
    y2: 25,
    stroke: "#78C15A",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 75,
    y1: 70,
    x2: 75,
    y2: 32,
    stroke: "#78C15A",
    strokeWidth: 2
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_3_205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.0007 31.8283L70.0509 36.7781L68.6367 35.3639L75.0007 28.9999L81.3646 35.3639L79.9504 36.7781L75.0007 31.8283Z",
    fill: "#78C15A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0007 31.8283L70.0509 36.7781L68.6367 35.3639L75.0007 28.9999L81.3646 35.3639L79.9504 36.7781L75.0007 31.8283Z",
    fill: "#78C15A"
  }))), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 64,
    y1: 27,
    x2: 88,
    y2: 27,
    stroke: "#78C15A",
    strokeWidth: 2
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_3_205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.9993 69.1717L79.9491 64.2219L81.3633 65.6361L74.9993 72.0001L68.6354 65.6361L70.0496 64.2219L74.9993 69.1717Z",
    fill: "#78C15A"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_3_205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.9993 69.1717L79.9491 64.2219L81.3633 65.6361L74.9993 72.0001L68.6354 65.6361L70.0496 64.2219L74.9993 69.1717Z",
    fill: "#78C15A"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 24,
    y2: -1,
    transform: "matrix(1 -4.37114e-08 -4.37114e-08 -1 65 73)",
    stroke: "#78C15A",
    strokeWidth: 2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(40)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3_205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(-1 0 0 -1 24 24)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3_205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(-1 0 0 -1 24 24)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_3_205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(0 -1 1 0 63 45)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_3_205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(0 1 -1 0 87 56)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_3_205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(0 1 -1 0 87 56)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTBed);
export default __webpack_public_path__ + "static/media/T-BED.74d7c182e905dff6437bbb40ed4577c0.svg";
export { ForwardRef as ReactComponent };